<template>
  <div class="marginEnquiry">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <UPDATE ref="childUpdate" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
import Url from '@/views/newmis36/util/url'
import FORM from '@/components/page/form'
import UPDATE from '@/components/page/update'

export default {
  name: 'marginEnquiry',
  components: {
    FORM,
    UPDATE
  },
  data() {
    return {
      queryData: {},
      /*form查询表单*/
      formData: {
        hasLable: true,
        cols: []
      },
      /*add或update浮窗表单*/
      updateData: {
        modelName: '查询结果',
        cols: [],
        submit: 'hide'
      },
    }
  },
  methods: {
    /*form按钮点击事件*/
    formclick(clickName, data) {
      if (clickName == window.$t('common.search')) {
        if (data.customerNo != undefined && data.customerNo != '') {
            this.$axios.get(Url.tracker.margin+"?customerNo="+data.customerNo).then(res => {
                if (res.code == 0 && res.result) {
                    this.updateData.cols.find(c => c.field === 'customerNo').data = data.customerNo
                    this.updateData.cols.find(c => c.field === 'marginLack').data = res.result.marginLack
                    this.updateData.cols.find(c => c.field === 'totalDeposit').data = res.result.totalDeposit
                    this.updateData.cols.find(c => c.field === 'totalMargin').data = res.result.totalMargin
                    this.$refs.childUpdate.open()
                } else {
                    this.$message.error(res.message)
                }
            })
        }
      }
    },
  },
  created() {
      /*表单初始化*/
      this.formData.cols = [
        { title: '客戶帐号', field: 'customerNo' },
        { click: window.$t('common.search'), icon: 'el-icon-search' },
      ]
      this.updateData.cols = [
        { title: '客戶帐号', field: 'customerNo', type: 17 },
        { title: '尚欠保证金金额', field: 'marginLack', type: 17 },
        { title: '总存款', field: 'totalDeposit', type: 17 },
        { title: '总开仓保证金', field: 'totalMargin', type: 17 },
      ]
  }
}
</script>
